import styled from 'styled-components'
import Flex from 'components/Flex'
import { Form as AntdForm } from 'antd'

export const FormItem = styled(AntdForm.Item)`
  margin-top: 0px;
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0px'} !important;
  width: 100%;
  .ant-form-item-explain-error {
    padding-left: ${props => (props.padding ? '15%' : '0')};
  }
  .ant-form-item-control-input {
    min-height: 0px;
  }
`

export const Container = styled(Flex)`
  width: 100%;
  height: auto;
  padding: 25px;
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  margin-bottom: 20px;
`
export const Heading = styled.div`
  font-weight: 600;
  font-size: 1.1428571428571428em;
  line-height: 21px;
  color: ${props => (props.color ? props.color : '#010e30')};
  margin-bottom: 5px;
  font-size: 16px;
`
export const SubHeading = styled.div`
  font-weight: 500;
  font-size: 0.8571428571428571em;
  line-height: 15px;
  color: #999fac;
`
export const SubHeading1 = styled.div`
  font-weight: 500;
  font-size: 10px;
  line-height: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  color: #999fac;
`

export const MarksFlex = styled(Flex)`
  gap: 20px;
  width: 50%;
  margin-top: 10px;
`
export const IconView = styled.div`
  cursor: 'pointer';
`
export const CurrentWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #cccfd6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  text-align: center;
  margin-right: 10px;
  height: 25px;
`

export const CurrentText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  align-items: center;
  text-align: center;
  color: #323538;
  display: flex;
  padding: 0px 10px;
`
